export type HelpItemAction = 'reactivateTour' | 'openHelp';

export interface HelpItem {
  id: string;
  labelKey: 'reactivateTour' | 'help';
  action: HelpItemAction;
}

export const HELP_URL = 'https://help.tapybl.com/support/home';

export const helpItems: HelpItem[] = [
  {id: 'reactivate-tour', labelKey: 'reactivateTour', action: 'reactivateTour'},
  {id: 'open-help', labelKey: 'help', action: 'openHelp'},
];
